import { FC } from 'react';

import { VSpacing, Text } from '@hh.ru/magritte-ui';

import FormatMoney from 'src/components/FormatMoney';
import { getTextStyle } from 'src/components/ResumeCard/utils/getTextStyle';
import type { Salary as SalaryType } from 'src/models/resume/resumeCommon.types';

interface Props {
    isVisited: boolean;
    salary: SalaryType;
}

const Salary: FC<Props> = ({ isVisited, salary }) => {
    return (
        <>
            <VSpacing default={2} />
            <Text typography="subtitle-2-semibold" style={getTextStyle(isVisited)}>
                <FormatMoney currency={salary.currency}>{salary.amount}</FormatMoney>
            </Text>
        </>
    );
};

export default Salary;
